module.exports = __webpack_public_path__ + "static/img/direction_filter_icon.949b04d6.svg";